const spacing = (num) => num * 4;

export { spacing };
